module.exports = __webpack_public_path__ + "img/user-krogec.ee646fc4.svg";